export const getColumnStyle = (width = 120) => ({
  width: `${width}px`,
  maxWidth: `${width}px`,
  minWidth: `${width}px`,
});
